import type {ReactElement} from 'react';
import React from 'react';
import {AddItemContainer} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-container';
import {onOpenUserMediaModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import {UploadIcon} from '@Components/upload-icon';
import {LoadingText} from '@Components/loading-text';
import type {TextProps} from '@Components/text';
import {TextSize} from '@Components/text';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import type {ElementTestId} from '@Tests/tests.types';
import {useAppSelector} from '@/hooks';
import styles from './add-user-media-button.module.scss';

interface AddUserMediaButtonProps {
  id: string;
  'data-testid'?: ElementTestId;
}

export function AddUserMediaButton({...props}: AddUserMediaButtonProps): ReactElement<any> {
  const isUploading = useAppSelector((state) => {
    return state.posterEditor.isUploadingToMyUploads;
  });

  const getInnerContent = (): ReactElement<any> => {
    const loadingTextProps: TextProps = {
      bold: isUploading,
      val: isUploading ? window.i18next.t('pmwjs_uploading_no_dots') : window.i18next.t('pmwjs_myuploads_capitalized'),
      size: TextSize.XXSMALL,
      className: `${isUploading ? styles.aiUploadingTextColor : undefined} ${styles.text}`,
    };

    return (
      <>
        {isUploading ? <UploadIcon isAnimating={isUploading} hasAIColor /> : <Icon icon="icon-upload-1" size={IconSize.SIZE_ICON_24} />}
        <LoadingText textProps={loadingTextProps} isAnimating={isUploading} className={'flex-content-center'} />
      </>
    );
  };

  return (
    <AddItemContainer id={props.id} onClick={onOpenUserMediaModal} data-testid={props['data-testid']}>
      {getInnerContent()}
    </AddItemContainer>
  );
}
